module.exports = __webpack_public_path__ + "img/ccf-es-ES.1b0596a2.png";